import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
    const subTenantId = decodedToken?.subTenantId;
    return subTenantId ? `&subTenantId=${subTenantId}` : "";
  } else if (switched && switchedSubtenant) {
    return `&subTenantId=${switchedSubtenant?.id}`;
  }
  return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

// Common headers
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  // only tenant-admin OR if subTenantId is missing
  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const ProductApi = {

    FilterProductsBySupplier: (supplierId, page = 0, limit = 100) => {
    const filterParam = window.btoa(
      `componentCode=PRODUCT&productToSuppliers.supplier.id=${supplierId}`
    );

    const url = `/filter/data?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}&filterParam=${filterParam}${getSubTenantIdParam()}`;

    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Create Product
  CreateProduct: (data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .post(`/product`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Update Product
  PutProduct: (ProductID, data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .put(`/product/${ProductID}`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List Products
  Listproducts: (page, limit) => {
    const url = `/product?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

   // List Products have stocks
  ListproductsStock: (page, limit) => {
    const url = `/product/in-stock?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Single Product by ID
  SingleProducts: (productID) => {
    const url = `/product/${productID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  //get by barcode
  GetByBarCode: (Barcode) => {
    const url = `/product/barCode/${Barcode}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },


  // Delete Product by ID
  DeleteProduct: (ProductID) => {
    const url = `/product/${ProductID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .delete(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Download CSV
  DownloadCSV: () => {
    const url = `/data-process/products/download?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Upload CSV
  UploadCSV: (data) => {
    return apiApp
      .post(`/data-process/products`, data, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  ExportProducts: (subTeanntId) => {
    const url = `/product/export?tenantId=${decodedToken?.tenantId}${subTeanntId ? `&subTenantId=${subTeanntId}` : getSubTenantIdParam()
      }`;

    return apiApp
      .get(url, {
        headers: getHeaders(),
        responseType: "blob"   // ✅ important for Excel/binary files
      })
      .then((res) => {
        // ✅ use correct Excel MIME type
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // ✅ create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // try to detect filename from backend, fallback to products.xlsx
        const disposition = res.headers["content-disposition"];
        let filename = "products.xlsx";
        if (disposition && disposition.includes("filename=")) {
          filename = disposition.split("filename=")[1].replace(/['"]/g, "").trim();
        }

        link.download = filename;
        document.body.appendChild(link);
        link.click();

        // cleanup
        link.remove();
        window.URL.revokeObjectURL(url);

        return res.data;
      })
      .catch((err) => Promise.reject(err?.response?.data));
  },

  ImportProducts: (file, subTenantId) => {
    const url = `/product/import?tenantId=${decodedToken?.tenantId}${subTenantId ? `&subTenantId=${subTenantId}` : getSubTenantIdParam()
      }`;

    const formData = new FormData();
    formData.append("file", file); // backend should accept "file" key

    return apiApp
      .post(url, formData, {
        headers: {
          ...getHeaders(),
          "Content-Type": "multipart/form-data", // ✅ ensure file upload
        },
      })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // get product by barcode
  GetProductByBarcode: (barcode, supplierName) => {
    const tenantCode = decodedToken?.tenantCode !== undefined ? decodedToken?.tenantCode : "";
    const subTenantCode = decodedToken?.subTenantCode !== undefined ? decodedToken?.subTenantCode : "";

    // Convert supplier name spaces to underscores
    const formattedSupplierName = supplierName ? supplierName.replace(/\s+/g, '_') : "";

    // Format: tenantCode + subTenantCode + "_" + supplierName + "_#" + barcode
    const modifyBarcode = `${tenantCode}${subTenantCode}_${formattedSupplierName}_#${barcode}`;

    const url = `/product/productCode/${encodeURIComponent(modifyBarcode)}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },


};

export default ProductApi;
